"use client";

import { cn } from "@ui/lib/utils";
import { RepeatIcon } from "lucide-react";
import { useTranslations } from "next-intl";

import { toggleLoopEditMode } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { SoundBoardButton } from "./SoundBoardButton";

export const LoopButton = ({ full = false }: { full?: boolean }) => {
  const { dispatch, state } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");
  return (
    <SoundBoardButton
      className={cn("control-button", state.isInLoopEditMode && "selected", !full && "flex-1")}
      fixedSize={full}
      onClick={() => dispatch(toggleLoopEditMode())}
    >
      {full && <RepeatIcon className='text-inverse' size={24} />}
      <p className='font-soundboard f-ui-04 w-full truncate text-inverse'>{t("loop_button.label")}</p>
    </SoundBoardButton>
  );
};
